import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { UntypedFormControl } from '@angular/forms'

import { Subscription } from 'rxjs'
import { TouaregControlDisplayService } from '../../services/touareg-control-display.service'
import {
  HealthMonitorData,
  TouaregControlStateHealthMonitorService,
} from '../../services/touareg-control-state-health-monitor.service'
import { TouaregControlStateParamsService } from '../../services/touareg-control-state-params.service'
import { Samv2Module } from '@aubert-et-duval/samv2';
import { PingComponent } from '@/modules/commons/components/ping/ping.component';

@Component({
  selector: 'app-touareg-control-toolbar',
  templateUrl: './touareg-control-toolbar.component.html',
  styleUrls: ['./touareg-control-toolbar.component.scss'],
  imports: [Samv2Module, PingComponent],
})
export class TouaregControlToolbarComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<MouseEvent>()

  private _healthSubs$!: Subscription
  private _ctrlSubs$!: Subscription

  public autoShowCtrl!: UntypedFormControl
  public health: HealthMonitorData = {} as HealthMonitorData

  constructor(
    private _params: TouaregControlStateParamsService,
    private _monitor: TouaregControlStateHealthMonitorService,
    public displayService: TouaregControlDisplayService
  ) {}

  ngOnInit(): void {
    // this._touaregStatesSubs$ = this._network.networkChange$.subscribe(
    //   ({ network }) => {
    //     this.isOnline = network
    //     if (network) document.body.classList.remove('is-offline')
    //     else document.body.classList.add('is-offline')
    //   }
    // )
    // const { autoShow } = this._params.getLocalDisplay() || {}
    // this.autoShowCtrl = new FormControl(autoShow)

    // this._ctrlSubs$ = this.autoShowCtrl.valueChanges.subscribe((autoShow) => {
    //   this._params.setLocalDisplay({ autoShow })
    // })

    this._healthSubs$ = this._monitor.health$.subscribe((health) => {
      this.health = health || ({} as HealthMonitorData)
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._healthSubs$) this._healthSubs$.unsubscribe()
    if (!!this._ctrlSubs$) this._ctrlSubs$.unsubscribe()
  }
}
